import React, { Component } from "react";
import "./homeStyle.css";
import Footer from "../components/Footer";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
    };
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <Footer />
      </div>
    );
  }
}
